{
  "just-now": "Just Now",
  "empty-history": "Empty History",
  "just": "just",
  "minutes": "m",
  "hours": "h",
  "days": "d",
  "actor-action": "{{name}} just {{action}}",
  "unknown-action": "made an update",
  "unknown-actor": "Someone",
  "desktop-title": "Championship Title · Order {{code}}",
  "desktop-title-plain": "Championship Title",
  "popover-title": "Notifications",
  "clear-all": "Clear all",
  "empty-hint": "Updates from teammates on your open orders appear here.",
  "enable-desktop": "Enable desktop notifications",
  "desktop-blocked": "Desktop notifications are blocked in your browser settings.",
  "open-order": "Open order {{code}}",
  "unread-label": "Unread",
  "bell-label": "Notifications",
  "bell-label-unread": "Notifications, {{count}} unread",
  "createOrder": "created an order",
  "createOrderAssociation": "associated a party",
  "createOrderFile": "added a file",
  "createOrderFileData": "added file information",
  "createOrderLedgerAssociation": "added a ledger association",
  "createOrderLedgerEntry": "added a ledger entry",
  "createOrderLedgerLink": "added a ledger link",
  "createOrderLoan": "added a loan",
  "createOrderLoanInterest": "added an interest",
  "createOrderMortgage": "added a mortgage",
  "createOrderMortgageAssociation": "associated a party with a mortgage",
  "createOrderPolicyEndorsement": "added a policy endorsement",
  "createOrderProperty": "added a property",
  "createOrderProration": "added a tax or proration",
  "deleteOrderArchive": "removed an archive",
  "deleteOrderAssociation": "disassociated a party",
  "deleteOrderFile": "removed a file",
  "deleteOrderFileData": "removed file information",
  "deleteOrderLedgerAssociation": "removed a ledger association",
  "deleteOrderLedgerEntry": "removed a ledger entry",
  "deleteOrderLedgerLink": "removed a ledger link",
  "deleteOrderLoan": "removed a loan",
  "deleteOrderLoanInterest": "removed an interest",
  "deleteOrderMortgage": "removed a mortgage",
  "deleteOrderMortgageAssociation": "disassociated a party from a mortgage",
  "deleteOrderPolicyEndorsement": "removed a policy endorsement",
  "deleteOrderProperty": "removed a property",
  "deleteOrderProration": "removed a tax or proration",
  "generateOrderFiles": "regenerated files",
  "helpOrderByAI": "created an order with help from artificial intelligence",
  "helpOrderChargesByAI": "imported charges with help from artificial intelligence",
  "helpOrderCharges": "used helper to modify charges",
  "helpOrderLedgerEntryLinked": "used helper to link a ledger entry",
  "helpOrderLedgerPayeePayer": "used helper to set payee/payer information",
  "requestOrderFiles": "requested files",
  "reviseOrderLedger": "asked for accounting revision",
  "updateOrderArchive": "updated archive information",
  "updateOrderCash": "updated cash to close",
  "updateOrderCommmitment": "updated commitment information",
  "updateOrderConfiguration": "updated order configuration",
  "updateOrderFile": "updated file information",
  "updateOrderLedgerAssociation": "updated a ledger association",
  "updateOrderLedgerEntry": "updated a ledger entry",
  "updateOrderLoan": "updated loan information",
  "updateOrderMortgage": "updated mortgage information",
  "updateOrderPolicy": "updated policy information",
  "updateOrderProperty": "updated property information",
  "updateOrderProration": "updated tax or proration information",
  "updateOrderSpecifics": "updated specific information",
  "updateOrderTokens": "updated access tokens",
  "workerAccountAddition": "added encrypted account information",
  "workerAccountRemoval": "removed encrypted account information",
  "workerAccountingLedger": "regenerated accounting spreadsheet",
  "workerDocumentGenerator": "regenerated content for all files",
  "workerFrostAuthorization": "registered a wire transfer authorization",
  "workerFrostRecords": "generated wire transfer records",
  "workerFrostRequest": "started a wire transfer process",
  "workerFrostSubmission": "submitted wire transfer records",
  "workerLoadNarrative": "redacted order narrative",
  "workerTagReplacer": "replaced template tags",
  "createAddress": "added an address",
  "createAutoTemplate": "added an auto template",
  "createChargeSetting": "added a charge setting",
  "createEmail": "added an email",
  "createLicense": "added a license",
  "createNotification": "added a notification",
  "createParty": "added a party",
  "createPartyAssociation": "associated a party",
  "createPartyPayment": "added a party payment",
  "createPhone": "added a phone number",
  "createTransferRequest": "created a transfer request",
  "createUser": "created a user",
  "deleteAddress": "removed an address",
  "deleteAutoTemplate": "removed an auto template",
  "deleteChargeSetting": "removed a charge setting",
  "deleteEmail": "removed an email",
  "deleteLicense": "removed a license",
  "deleteNotification": "removed a notification",
  "deleteParty": "removed a party",
  "deletePartyAssociation": "disassociated a party",
  "deletePartyPayment": "removed a party payment",
  "deletePhone": "removed a phone number",
  "deleteUser": "removed a user",
  "helpOrderLinkedEntry": "used helper to link an entry",
  "mergeDocuments": "merged documents",
  "requestNetworkAccess": "requested network access",
  "requestSignature": "requested a signature",
  "resetPassword": "reset a password",
  "sendNotification": "sent a notification",
  "updateAddress": "updated an address",
  "updateAutoTemplate": "updated an auto template",
  "updateChargeSetting": "updated a charge setting",
  "updateEmail": "updated an email",
  "updateLicense": "updated a license",
  "updateLocalPassword": "updated local password",
  "updateNotification": "updated a notification",
  "updateOrderCommitment": "updated commitment information",
  "updateOrderLedgerPosted": "updated ledger post date",
  "updateOrderLedgerStatus": "updated ledger status",
  "updateOrderProjected": "updated projected amounts",
  "updateParty": "updated party information",
  "updatePartyNotifications": "updated party notifications",
  "updatePhone": "updated a phone number",
  "updateUserNotes": "updated user notes",
  "updateOrderFileData": "updated file information",
  "createOrderNote": "added a note",
  "updateOrderNote": "updated a note",
  "deleteOrderNote": "removed a note",
  "helpOrderLedgerEntryParties": "used helper to set ledger entry parties",
  "deleteOrderLedgerRole": "removed a ledger role",
  "createAssociation": "associated a party",
  "deleteAssociacion": "disassociated a party",
  "createNewProperty": "added a property",
  "deleteProperty": "removed a property",
  "updateProperty": "updated property information"
}
